import {
  CreateCollectionRequest,
  DeleteCollectionRequest,
  UpdateCollectionRequest,
  ViewAllCollectionsRequest
} from './collection.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/collection`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateCollectionRequest = (
  data: CreateCollectionRequest
): [string, HttpPostOptions<CreateCollectionRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewAllCollectionsRequest = (data: ViewAllCollectionsRequest): [string, HttpGetOptions] => [
  getSpecificEndpoint(data.programmeExternalReference),
  getHttpGetOptions()
];

export const getUpdateCollectionRequest = (
  data: UpdateCollectionRequest
): [string, HttpPutOptions<UpdateCollectionRequest>] => [getEndpoint(), getHttpPutOptions(data)];

export const getDeleteCollectionRequest = (data: DeleteCollectionRequest): [string, HttpDeleteOptions] => [
  `${getEndpoint()}/${data.programmeExternalReference}/${data.planExternalReference}`,
  getHttpDeleteOptions()
];
